import React, { useState } from 'react';
import { Cancel01Icon } from 'hugeicons-react';

/**
 * Practice close button with X icon (or "Back to Home" text) and confirmation modal.
 * Replaces the back button on Quick/Writing/Speaking practice pages.
 * @param {string} variant - 'icon' (X) or 'text' (Back to Home)
 */
function PracticeCloseButton({ onClose, className = '', inWebView = false, variant = 'icon', confirmMessage = 'Progress yang belum diselesaikan tidak akan tersimpan.', 'aria-label': ariaLabel = 'Close practice' }) {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    setShowModal(false);
    onClose?.();
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  if (!onClose) return <span />;

  const isTextVariant = variant === 'text';

  return (
    <>
      <button
        type="button"
        className={`practice-close-button flex items-center justify-center cursor-pointer transition-all duration-300 ease-out ${inWebView ? 'ml-0 mr-auto ' : ''} ${isTextVariant ? 'py-3.5 px-10 max-md:px-6 max-md:py-3.5 max-md:w-full max-md:min-h-[44px] bg-transparent text-[#12766d] dark:text-[var(--accent-teal)] border-2 border-[#12766d] dark:border-[var(--accent-teal)] rounded-xl text-base max-md:text-[15px] font-semibold hover:bg-[rgba(18,118,109,0.05)] dark:hover:bg-[rgba(20,184,166,0.08)] hover:-translate-y-px' : 'p-2 min-w-[38px] min-h-[38px] bg-transparent border-2 border-[rgba(18,118,109,0.2)] rounded-lg text-[var(--accent-teal)] hover:border-[#12766d] hover:bg-[rgba(18,118,109,0.05)]'} ${className}`.trim()}
        onClick={handleClick}
        aria-label={ariaLabel}
      >
        {isTextVariant ? 'Back to Home' : <Cancel01Icon size={22} color="currentColor" strokeWidth={2} />}
      </button>

      {showModal && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10050] p-4"
          onClick={handleCancel}
          role="presentation"
        >
          <div
            className="bg-[var(--card-bg)] rounded-2xl p-6 max-w-[360px] w-full shadow-[var(--shadow-md)]"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="practice-close-modal-title"
          >
            <h3
              id="practice-close-modal-title"
              className="m-0 mb-2 text-lg font-semibold text-[var(--text-primary)]"
            >
              Keluar dari practice?
            </h3>
            <p className="m-0 mb-5 text-sm text-[var(--text-secondary)] leading-relaxed">
              {confirmMessage}
            </p>
            <div className="flex gap-3 justify-end">
              <button
                type="button"
                className="px-5 py-2.5 rounded-lg text-sm font-semibold cursor-pointer transition-all duration-200 bg-transparent border-2 border-[rgba(18,118,109,0.2)] text-[var(--accent-teal)] hover:border-[#12766d] hover:bg-[rgba(18,118,109,0.05)]"
                onClick={handleCancel}
              >
                Batal
              </button>
              <button
                type="button"
                className="px-5 py-2.5 rounded-lg text-sm font-semibold cursor-pointer transition-all duration-200 bg-[#12766d] border-none text-white hover:bg-[#0f6058]"
                onClick={handleConfirm}
              >
                Ya, keluar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PracticeCloseButton;
